/* Copyright (c) 2017 Backpack Health LLC */

import React from 'react';
import { FormattedMessage } from 'react-intl';

import ContentFrame from '../../applicationFrame/ContentFrame';
import { ScrollAwareContext, ScrollAwareScroller, ScrollAwareAppNavStep } from '../../components/ScrollAware';
import { AppHeaderScrollableText } from '../../components/appNav/AppHeaderScrollable';
import { Button } from '../../components/buttons/Buttons';
import Card, { CardSection } from '../../components/card/Card';
import PreformattedText from '../../components/PreformattedText';
import ContentWrapper from '../../components/ContentWrapper';
import RouteNames from '../RouteNames';
import { useNavigate } from '../../hooks/useNavigate';

const ConfirmDelete = () => {
  const [, navActions] = useNavigate();
  return (
    <div>
      <ScrollAwareContext>
        <ScrollAwareAppNavStep
          cancel={() => {
            navActions.goBack(RouteNames.accountSettings());
          }}
          color="white"
        />

        <ContentFrame>
          <ScrollAwareScroller>
            <AppHeaderScrollableText
              id="deleteAccountConfirm.title.text"
            />
            <ContentWrapper>
              <Card>
                <CardSection hasBorder={false}>
                  <PreformattedText
                    textClassName="font-color-gsDark font-subhead"
                    text="deleteAccountConfirm.delete.message.text"
                  />
                </CardSection>
              </Card>

              <Button
                className="bkgd-color-csError font-body"
                size="wide"
                style={{ marginTop: 0 }}
                onClick={() => {
                  navActions.goTo(RouteNames.deleteAccountSurvey());
                }}
              >
                <FormattedMessage id="deleteAccountConfirm.delete.button.label" />
              </Button>
            </ContentWrapper>
          </ScrollAwareScroller>
        </ContentFrame>
      </ScrollAwareContext>
    </div>
  );
};

export default ConfirmDelete;
